import { useEffect, useState } from "react";
import { StandardButton } from "../../atoms/buttons";
import { ExpligoBadge } from "../expligobadge";
import { Spinner } from "../../atoms/spinner";
import { TitleAtom } from "../../atoms/titleAtom";
import { HorizontalLayout, VerticalLayout } from "../layout";
import CollapsibleText from "../../molecule/CollapsibleText";
import { icon } from "../../functions/icons";
import ExpligoWP from "../../assets/expligo_wp2.png";
import { motion } from "framer-motion";
import useFullHeight from "../../hooks/useFullHeight";

export default function ElearningFeed({ elearningFeedData, startEmbedAssessmentNow, setCurrentAssessment }) { 
  useFullHeight();
  const [embedBtnState, setEmbedBtnState] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
 
  const startEmbedAssessment = () => {
    
    setEmbedBtnState(1);
    startEmbedAssessmentNow();
    setTimeout(() => {
      
    }, 1500);
  };

  const handleScroll = (e) => {
    const scrollPosition = e.target.scrollTop;
    const containerHeight = e.target.clientHeight;
    const newIndex = Math.round(scrollPosition / containerHeight);
    setActiveIndex(newIndex);
    setCurrentAssessment(newIndex);
  };
  if (!elearningFeedData || elearningFeedData.length === 0) {
     return (
      <EmptyFeed />
    );
  }

  return (
    <HorizontalLayout className="elearning-feed-container" onScroll={(e) => handleScroll(e)} style={{ display:"block",height: "100dvh" }}>
      {elearningFeedData.map((course, index) => (
        <div key={course.id || index} style={{ height: "100dvh", scrollSnapAlign: "start" }}>
          <ElearningCard
            elearningInformation={course}
            startEmbedAssessment={startEmbedAssessment}
            embedBtnState={embedBtnState}
            elearningFeedData={elearningFeedData}
            index={index}
          />
        </div>
      ))}
      <Indicator activeIndex={activeIndex} elearningFeedData={elearningFeedData} />
    </HorizontalLayout>
  );
}


const ElearningCard = ({ elearningInformation, startEmbedAssessment, embedBtnState,elearningFeedData, index}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth < 768;
    useEffect(() => {
      const onResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);
  return (
    <VerticalLayout className="complete-height dark-background elearning-embed-card" style={{overflow: "hidden", justifyContent: "flex-end",height:"100dvh"}} >
      <img
        className="elearning-background-image dark-background"
        src={elearningInformation.image_url}
        alt={elearningInformation.title || "Cursus afbeelding"}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      />
      <div className="elearning-background-overlay"></div>
        {index === 0 && elearningFeedData.length > 1 && <ScrollHint />}
      <HorizontalLayout
        className="elearning-thumbnail-bottom space-between"
        style={{
          width: "auto",
          background: "linear-gradient(0deg, rgba(0,0,0,0.65) 50%, rgba(0,0,0,0.0) 100%)",
          position: "relative",
          zIndex: 2,
          padding: "2rem",
          color: "white",
        }}
      >
    
        <VerticalLayout className="bottom-text-container">
          
          <TitleAtom
            className={"bottom-text-title"}
            title={elearningInformation.title}
          />
          <CollapsibleText maxLength={isMobile ? 100 : 150} text={elearningInformation.description}  extra={elearningInformation?.extra_description|| ""}/>
        </VerticalLayout>

        <StandardButton
          backgroundColor="white"
          textColor="standard-text-color"
          onClick={startEmbedAssessment}
          className={"button-embedcourse"}
          isDisabled={embedBtnState === 1}
        >
          {embedBtnState === 1 ? (
            <Spinner color="grey-900" size="1.5rem" />
          ) : (
            "Starten"
          )}
        </StandardButton>
      </HorizontalLayout>

      <ExpligoBadge />
    </VerticalLayout>
  );
};
const Indicator = ({ activeIndex, elearningFeedData }) => {
  const total = elearningFeedData.length;
  const maxDots = 3;
  const dotSize = 12;
  const gap = 8;
  const startIndex = Math.floor(activeIndex / maxDots) * maxDots;
  const endIndex = Math.min(startIndex + maxDots, total);
  const visibleDots = elearningFeedData.slice(startIndex, endIndex);
  const activeDotRelative = activeIndex - startIndex;
  const hasMoreAbove = startIndex > 0;
  const hasMoreBelow = endIndex < total;
  const arrowSize = 20;

  return (
    <div
      aria-hidden={total <= 1}
      style={{
        position: "fixed",
        right: "1rem",
        top: "50%",
        transform: "translateY(-50%)",
        height: `${(dotSize + gap) * maxDots + 2 * arrowSize}px`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
        pointerEvents: "none",
      }}
    >
      {hasMoreAbove && icon("arrow-up", 20, "var(--white)")}
      {visibleDots.map((_, idx) => (
        <div
          key={idx}
          style={{
            width: dotSize,
            height: dotSize,
            borderRadius: "50%",
            margin: `${gap / 2}px 0`,
            backgroundColor: "rgba(255,255,255,0.4)",
            position: "relative",
          }}
        >  
          <motion.div
            layout
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: dotSize,
              height: dotSize,
              borderRadius: "50%",
              backgroundColor: "white",
              boxShadow: "0 0 8px rgba(255,255,255,0.12)",
            }}
            animate={{ y: (activeDotRelative - idx) * (dotSize + gap) }}
            transition={{ type: "spring", stiffness: 200, damping: 25 }}
          />
        </div>
      ))}
      {hasMoreBelow && icon("arrow-down", 20, "var(--white)")}
    </div>
  );
};

const ScrollHint = () => (
  <div className="scroll-hint">
    <p style={{fontSize:"0.8rem"}}>Meer ontdekken</p>
    <div>
    {icon("arrow-down", 30)}
    </div>
  </div>
);

const EmptyFeed = () => (
  <VerticalLayout className="complete-height center-all" style={{ position: "relative" , height: "100dvh"}}>
      <img
        src={ExpligoWP}
        alt="Expligo Wallpaper"
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          top: 0,
          left: 0,
          zIndex: 0,
        }}
      />
      <div className="elearning-background-overlay" />
      <VerticalLayout className="center" style={{ position: "relative", zIndex: 2, textAlign: "center" }}>
        <h3 style={{ color: "var(--white)", textShadow: "0 0 10px rgba(0,0,0,0.8)" }}>
          Er zijn nog geen cursussen beschikbaar voor jou.
        </h3>
        <p style={{ color: "var(--white)", textShadow: "0 0 10px rgba(0,0,0,0.8)" }}>
          Kom later terug om je leertraject te starten!
        </p>
      </VerticalLayout>
    </VerticalLayout>
)